var agp = agp || {};

agp.events = (function () {

    function AppEvent(eventName) {

        this.unbindables = {};

        this.trigger = function (parameter) {
            $(document).trigger(eventName, parameter);
        };

        this.listen = function (callback, unbindId) {
            this.unbind(unbindId);

            var wrapper = function (event, parameter) {
                callback(parameter);
            };

            if (unbindId != null) {
                this.unbindables[unbindId] = wrapper;
            }

            $(document).bind(eventName, wrapper);
        };

        this.unbind = function (unbindId) {
            if (unbindId != null && this.unbindables.hasOwnProperty(unbindId)) {
                $(document).unbind(eventName, this.unbindables[unbindId]);
            }
        }
    }

    window.Events = {
        NemIdDocumentSignInit: new AppEvent("NemIdDocumentSignInit"),
        NemIdDocumentSignMessage: new AppEvent("NemIdDocumentSignMessage"),
        NemIdDocumentSigned: new AppEvent("NemIdDocumentSigned"),
        NemIdDocumentSignCancelled: new AppEvent("NemIdDocumentSignCancelled"),
        NemIdDocumentSignError: new AppEvent("NemIdDocumentSignError"),
        NemIdLoginError: new AppEvent("NemIdLoginError"),
        NemIdLoginCancelled: new AppEvent("NemIdLoginCancelled"),
        NemIdLoginLoggedIn: new AppEvent("NemIdLoggedIn"),
        NemIdDocumentSignNotTheSameUser: new AppEvent("NemIdDocumentSignNotTheSameUser")
    };
})();